import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, NgModule, OnInit } from '@angular/core';
import { Cms } from '@impact/data';
import { RichTextModule } from '../../rich-text/rich-text.module';
import { MapView, MapsLocation } from '../../maps/maps.component';
import { DealershipsModule } from '../../dealerships/dealerships.module';
import { MapsModule } from '../../maps/maps.module';
import { NewCarsModule } from '../../new-cars/new-cars.module';
import { SpotsUiModule } from '../spots-ui.module';
import { UmbracoGridModule } from '../../umbraco-grid/umbraco-grid.module';
import { GlobalDataService } from '../../core/global-data.service';
import { NavigationService } from '../../navigation/navigation.service';
import { forkJoin } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-dealership-spot',
    template: `
         <section class="dealership-page-section">
            <app-maps [vehicleMakeName]="vehicleMakeName"  [locations]="dealershipLocations"  [mapView]="mapView.DEALERSHIPS_WITH_MAKE"></app-maps>
        </section>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
class DealershipContentSpotComponent implements OnInit {

    @Input() data: Cms.DealershipContentSpot;

    mapView = MapView;
    dealershipsData: MapsLocation[] = [];
    dealershipLocations: MapsLocation[] = [];
    vehicleMakeName: string;

    constructor(
        private globalDataService: GlobalDataService,
        private navigationService: NavigationService,
        private cdr: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.vehicleMakeName = this.data?.vehicleMake?.name;
        this.mapDealershipsData();
    }

    mapDealershipsData(): void {
        forkJoin([
            this.globalDataService.getDealerships(),
            this.navigationService.dealershipsNavigation$.pipe(take(1))
        ]).subscribe(([dealerships, dealershipsNavigation]) => {
            dealershipsNavigation.forEach((navItem) => {
                if (navItem.dealerShipId) {
                    const matchingDealership = dealerships.children.find(dealership => dealership.id === navItem.dealerShipId);
                    if (matchingDealership) {
                        this.dealershipsData.push({
                            ...matchingDealership,
                            pageUrl: navItem.url
                        });
                    }
                }
            });

            if (this.dealershipsData.length) {
                this.findMakeDealerships(this.dealershipsData);
            } else {
                console.warn(`[BN error: No ${this.vehicleMakeName} dealerships found]`);
            }

        });
    }

    findMakeDealerships(dealershipsData: MapsLocation[]): void {
        dealershipsData.forEach((dealership) => {
            if (dealership.vehicleMakes) {
                if (dealership.vehicleMakes.some((make) => make.name.toLowerCase() === this.vehicleMakeName.toLowerCase())) {
                    this.dealershipLocations.push(dealership);
                }
            }
        });

        if (!this.dealershipLocations.length) {
            console.warn(`[BN error: No ${this.vehicleMakeName} dealerships found]`);
        }
        this.cdr.markForCheck();
    }

}


@NgModule({
    declarations: [DealershipContentSpotComponent],
    imports: [
        CommonModule,
        RichTextModule,
        MapsModule,
        DealershipsModule,
        NewCarsModule,
        SpotsUiModule,
        UmbracoGridModule
    ]
})
class DealershipContentSpotModule {}

export const LazySpotComponent = DealershipContentSpotComponent;
